import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    userIdentificationScroll: true,
};
const siteSlice = createSlice({
    name: 'siteReducer',
    initialState,
    reducers: {
        updateUserIdentificationScroll: (state, action) => {
            state.userIdentificationScroll = action.payload;
        },
    },
});
export const { actions } = siteSlice;
export default siteSlice.reducer;
